import React from "react";

const SelectField = ({
    label,
    value,
    isValid,
    onChange,
    options,
    placeholder = "Please Select",
}) => {
    return (
        <>
            <p>{label}</p>
            <select onChange={onChange} value={value}>
                <option value="">{placeholder}</option>
                {options.map((item, i) => {
                    return (
                        <option key={i} value={item.id}>
                            {item.text}
                        </option>
                    );
                })}
            </select>
            {!isValid && (
                <span style={{ color: "red", paddingLeft: "5px" }}>Required</span>
            )}
        </>
    );
};

export default SelectField;
